import { Divider, InputRichText } from '@dixa/lib-shared-habla';

import { useCopilotTrial } from 'utils/useCopilotTrial';
import { useEditorContext } from 'utils/useEditorContext';

export const Undo = (): JSX.Element | null => {
  const { undo, canUndo } = useEditorContext();
  const { hasCopilot } = useCopilotTrial();

  if (!hasCopilot || !canUndo()) {
    return null;
  }

  return (
    <>
      <Divider orientation="vertical" />
      <InputRichText.ToolbarButton icon="undo" text="Undo" onClick={undo} />
    </>
  );
};
